import { render, staticRenderFns } from "./ActiveBacklogCityDashboard.vue?vue&type=template&id=27e56a6f&"
import script from "./ActiveBacklogCityDashboard.vue?vue&type=script&lang=js&"
export * from "./ActiveBacklogCityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBacklogCityDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports